import compressLongString from "@/app/utils/strings/compressLongString";
import { useTheme } from "next-themes";
import React, { Fragment } from "react";
import { ProfileIcon, SleapLogo } from "../Icons";
import { ThirdWeb } from "./ThirdWeb";
import Image from "next/image";
import { usePathname } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

const ButtonSignIn = ({
  walletId,
  handleSignIn,
  loader,
  points,
  isCBOneAttested,
}: {
  walletId: string | null | undefined;
  handleSignIn: () => void;
  loader: boolean;
  points: number;
  isCBOneAttested: boolean;
}) => {
  const { theme } = useTheme();
  const pathname = usePathname();
  const isHomepage = pathname === "/";
  const t = useTranslations("Header.ButtonSignIn");

  return (
    <>
      <button className="p-0">
        <span
          onClick={handleSignIn}
          className={`flex items-center gap-1 rounded-full justify-center min-h-11 min-w-20 ${loader || walletId ? "md:px-6 xs:px-4 px-3" : "hover:bg-white bg-white transition dark:bg-sleap-gray-950 dark:hover:bg-sleap-gray-90"}`}
        >
          {walletId &&
            (isCBOneAttested ? (
              <span className="sm:hidden flex flex-col gap-x-2 gap-y-1 items-center justify-center">
                {isHomepage ? (
                  <Image
                    src="/assets/v2/coinbase-logo-light.svg"
                    className="h-6 w-6"
                    width={24}
                    height={24}
                    alt="Coinbase logo"
                  />
                ) : (
                  <>
                    <Image
                      src="/assets/v2/coinbase-logo-dark.svg"
                      className="h-6 w-6 block dark:hidden"
                      width={24}
                      height={24}
                      alt="Coinbase logo"
                    />
                    <Image
                      src="/assets/v2/coinbase-logo-light.svg"
                      className="h-6 w-6 hidden dark:block"
                      width={24}
                      height={24}
                      alt="Coinbase logo"
                    />
                  </>
                )}
                <span className="text-sm font-bold text-sleap-fern-200 flex items-center gap-1">
                  {points} {t("points")}
                </span>
              </span>
            ) : (
              <span className="sm:hidden flex flex-col gap-x-2 items-center justify-center">
                <ProfileIcon
                  color={theme == "dark" ? "lightWhite" : "lightblack"}
                  className="w-8 h-8"
                />
                <span className="text-sm font-bold text-sleap-fern-200 flex items-center gap-1">
                  {points} {t("points")}
                </span>
              </span>
            ))}
          <p
            className={`${
              walletId
                ? "font-base font-poppins text-base items-center gap-x-2"
                : "font-medium font-unbounded xs:text-sm text-xs"
            } text-sleap-gray-950 dark:text-lightwhite mb-0 sm:flex hidden`}
          >
            {walletId &&
              (isCBOneAttested ? (
                <Fragment>
                  {isHomepage ? (
                    <Image
                      src="/assets/v2/coinbase-logo-light.svg"
                      className="h-6 w-6"
                      width={24}
                      height={24}
                      alt="Coinbase logo"
                    />
                  ) : (
                    <>
                      <Image
                        src="/assets/v2/coinbase-logo-dark.svg"
                        className="h-6 w-6 block dark:hidden"
                        width={24}
                        height={24}
                        alt="Coinbase logo"
                      />
                      <Image
                        src="/assets/v2/coinbase-logo-light.svg"
                        className="h-6 w-6 hidden dark:block"
                        width={24}
                        height={24}
                        alt="Coinbase logo"
                      />
                    </>
                  )}
                  <span
                    className={`flex flex-col items-center ${
                      isHomepage ? "text-lightwhite" : ""
                    } font-medium font-inter`}
                  >
                    {compressLongString(walletId, 8, 8)}
                    <span
                      className={`text-sm ${
                        isHomepage ? "text-lightwhite" : ""
                      } flex items-center gap-1 font-inter`}
                    >
                      <span className="font-bold">
                        {points} {t("points")}
                      </span>{" "}
                      |<span className="font-bold">{t("coinbaseOne")}</span>
                    </span>
                  </span>
                </Fragment>
              ) : (
                <Fragment>
                  <ProfileIcon
                    color={theme == "dark" ? "lightWhite" : "lightblack"}
                  />
                  <span className="flex flex-col items-center">
                    {compressLongString(walletId)}
                    <span className="text-sm font-bold text-sleap-fern-200 flex items-center gap-1">
                      <SleapLogo /> {points} {t("points")}
                    </span>
                  </span>
                </Fragment>
              ))}

            <span
              className={`${
                walletId === undefined || loader ? "block" : "hidden"
              }`}
            >
              <span className="dots-container">
                <span className="dot !text-black"></span>
                <span className="dot !text-black"></span>
                <span className="dot !text-black"></span>
              </span>
            </span>
            {!loader && (
              <ThirdWeb
                walletId={walletId}
                theme={theme ?? ""}
                label={t("signIn")}
                className={`!min-w-5 !text-sm !text-sleap-gray-700 dark:!text-white !font-inter !font-medium flex justify-center items-center !h-11 ${
                  !walletId ? "!px-6 " : ""
                }`}
              />
            )}
          </p>
          <p
            className={`${
              walletId
                ? "font-base font-poppins text-base"
                : "font-medium font-unbounded xs:text-sm text-sm"
            } text-white mb-0 sm:hidden block`}
          >
            <ThirdWeb
              walletId={walletId}
              theme={theme ?? ""}
              label={t("signIn")}
              className={`!min-w-5 !text-sm !text-sleap-gray-700 dark:!text-white !font-inter !font-medium flex justify-center items-center ${
                !walletId ? "!px-3 h-11" : ""
              }`}
            />
          </p>
        </span>
      </button>
    </>
  );
};

export default ButtonSignIn;
